import { gql } from "apollo-boost";
import Error from 'components/alerts/Error';
import Success from 'components/alerts/Success';
import { Text } from 'components/common/form/modules/input/Text'
import { ContentLoader } from 'components/common/loader/ContentLoader';
import { openModal } from 'components/modal/modules/dispatcher/methods';
import { AppConfig } from 'config/app';
import EventToolbar from 'pages/manage/events/detail/EventToolbar';
import React from 'react';
import { Subscription } from "react-apollo";
import { withCookies } from "react-cookie";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { QRCode } from "react-qr-svg";
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { withRouter } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { Card, Row } from 'reactstrap';
import Col from 'reactstrap/lib/Col';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import { activateNewPrivate } from '../../../../../components/graphql/queries/ticket';
import { getTicketBankItemsPrivate } from '../../../../../components/graphql/queries/ticketBank';
import ActivatedTicketListItem from '../../../../../components/platform/ticket-list/ActivatedTicketListItem';
import TicketListItem from '../../../../../components/platform/ticket-list/TicketListItem';
import { stripUriParamsString } from '../../../../../lib/utils/helpers';
import UserDucks from '../../../../../stores/ducks/User.duck';
import PrintedTicketActivation from './PrintedTicketActivation';

import './style.css';

/**
 * The sell page, which is shown when any of the event cards are clicked on the events page.
 */
class ActivateDigitalTicketPage extends React.Component<
  { cookies: any, match?: any, userId?: any, user?: any; dispatch?: any },
  { [label: string]: any }
  > {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      tickets: [],
      isLoading: true,
      ticketOrder: {},
      ticketMap: {},
      teamMap: {
        code: '',
        customSubdomain: '',
        teamMap: [{
          userId: '', index: ''
        }]
      },
      formData: { comment: "" },
      activatedTicketCode: null,
      copied: false,
      updateString: 0,
      modified: false,
      eventName: '',
      onSale: true,
      currency: '',
      showReferral: false,
      email: '',
      invalidEmail: false,
      emailSent: false,
      generalLinkCopied: false,
      referralLinkCopied: false,
      capacityRemaining: 0
    };

    this.copied = this.copied.bind(this)
    this.getQty = this.getQty.bind(this);
    this.fetchNeededData = this.fetchNeededData.bind(this);
    this.countTotalPrice = this.countTotalPrice.bind(this);
    this.countTotalTickets = this.countTotalTickets.bind(this);
    this.handleAddTicket = this.handleAddTicket.bind(this);
    this.handleActivateTicket = this.handleActivateTicket.bind(this);
    this.handleBackToActivation = this.handleBackToActivation.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this)
    this.reloadData = this.reloadData.bind(this);
    this.openErrorModal = this.openErrorModal.bind(this);
    this.resetChangeMade = this.resetChangeMade.bind(this);
    this.changeMade = this.changeMade.bind(this);
    this.referralLinkCopied = this.referralLinkCopied.bind(this);
    this.generalLinkCopied = this.generalLinkCopied.bind(this);
  }

  public handleRoleChange(user: any) {
    this.props.dispatch(UserDucks.setUser(user));
    return undefined;
  }

  public generalLinkCopied() {
    this.setState({
      generalLinkCopied: true, referralLinkCopied: false
    })
  }

  public referralLinkCopied() {
    this.setState({
      generalLinkCopied: false, referralLinkCopied: true
    })
  }

  public handleActivateTicket(e: any) {
    this.setState({
      modified: true
    })
    const eventId = stripUriParamsString(this.props.match.params.eventId);
    const ticketComponents: any[] = [];
    Object.keys(this.state.ticketOrder).forEach(tkey => {
      if (this.state.ticketOrder[tkey].count > 0) {
        ticketComponents.push({
          ticketBankId: tkey,
          count: this.state.ticketOrder[tkey].count
        });
      }
    });
    fetchGraphQL(activateNewPrivate(), undefined, {
      eventId,
      ticketComponents,
      notes: this.state.formData.comment
    }).then(res => {
      if (res.ticket.activate === 'ERROR_SOLD_OUT') {
        window.location.reload();
        return;
      }
      this.setState({ activatedTicketCode: res.ticket.activate })
    });
  }
  public handleAddTicket(e: any, id: string, add: boolean) {

    e.preventDefault();
    const ticketOrder = this.state.ticketOrder;

    let count = 0;

    if (add) {
      count = 1;
    } else {
      count = -1;
    }

    if (add && this.state.tickets[this.state.ticketMap[id]].quantity === -1) {
      // Get total count and compare that to remaning capactiy.
      // Then proceed
      let totalSoFar = 0;
      Object.keys(ticketOrder).map(key => {
        if (this.state.tickets[this.state.ticketMap[key]].quantity === -1) {
          totalSoFar += ticketOrder[key].count
        }
      })
      if (totalSoFar >= this.state.capacityRemaining) {
        return
      }
    }

    let item: any = {};
    item = this.state.tickets.find(i => {
      return i._id.toString().trim() === id.toString().trim()
    })

    if (ticketOrder[id] === undefined) {
      if (add) {
        ticketOrder[id] = {
          count: 1,
          name: item!.name,
          price: item!.price
        };
        this.setState({ ticketOrder });
      } else {
        ticketOrder[id] = {
          count: 0,
          name: item!.name,
          price: item!.price
        };
      }
    } else {
      if (add) {
        if (
          this.state.ticketOrder[id].count < item!.available
        ) {
          ticketOrder[id].count += count;
          this.setState({ ticketOrder });
        } else {
          // toast.error("Limit Reached");
        }
      } else {
        if (ticketOrder[id].count > 0) {
          ticketOrder[id].count -= 1;
          this.setState({ ticketOrder });
        }
      }
    }
  }

  public componentDidMount() {
    this.fetchNeededData();

  }

  public emailInputChange(e) {
    this.setState({
      email: e.target.value,
      invalidEmail: false,
      emailSent: false
    })
  }

  public emailOffer() {
    const email = this.state.email.trim();
    if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
      this.setState({
        invalidEmail: true
      })
      return;
    }
    fetchGraphQL(`
      mutation {
        ticket {
          emailPrivateOffer(code:"${this.state.activatedTicketCode}",email:"${email}")
        }
      }
    `).then(res => {
      if (res.ticket.emailPrivateOffer === true) {
        this.setState({
          emailSent: true
        })
      }
    })
  }

  public reloadData(e: any, num: any) {
    if (num === 1) {
      this.setState({
        updateString: e
      })
    } else if (num === 4) {
      this.setState({
        updateString4: e
      })
    }

    this.fetchNeededData();
    return undefined;
  }

  public countTotalPrice() {
    let totalPrice = 0;
    Object.keys(this.state.ticketOrder).forEach(tkey => {
      totalPrice +=
        this.state.ticketOrder[tkey].count * this.state.ticketOrder[tkey].price;
    });

    return totalPrice;
  }

  public countTotalTickets() {
    let totalTickets = 0;
    Object.keys(this.state.ticketOrder).forEach(tkey => {
      totalTickets += this.state.ticketOrder[tkey].count;
    });

    return totalTickets;
  }

  public handleFormInputChange(e: any) {
    const { name, value } = e.target;

    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value
      }
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.user.id === "") {
      return
    }
    fetchGraphQL(`
    query {
      ticketBank {
        getReferral(eventId:"${stripUriParamsString(this.props.match.params.eventId)}",promoterId:"${nextProps.user.id}") {
          _id
        }
      }
    }
  `).then(res => {
      if (res.ticketBank.getReferral !== null && res.ticketBank.getReferral.length !== 0) {
        this.setState({
          showReferral: true
        })
      }
    })
  }

  public getQty(titemId: string): number {
    return this.state.ticketOrder[titemId]
      ? this.state.ticketOrder[titemId].count
      : 0;
  }

  public copied() {
    this.setState({ copied: true })
  }

  public fetchNeededData() {
    const eventId = stripUriParamsString(this.props.match.params.eventId);
    const userCookie = this.props.cookies.get("user")
    fetchGraphQL(`
    query {
      event {
        get(eventId: "${eventId}") {
          name
          onSale
          currency
          capacityRemaining
        }
      }
    }
    `).then(eventResult => {
      fetchGraphQL(getTicketBankItemsPrivate(), undefined, {
        eventId,
        promoterId: userCookie.id
      }).then((resultInventory: any) => {
        fetchGraphQL(`
        query {
          url {
            get(eventId: "${eventId}") {
              code
              customSubdomain
              teamMap {
                userId
                index
              }
            }
          }
        }
        `).then(res => {

          this.setState({
            teamMap: res.url.get || {
              code: '',
              customSubdomain: '',
              teamMap: [{
                userId: '', index: ''
              }]
            },
          })
          const ticketMap = {};
          if (resultInventory && resultInventory.ticketBank) {
            const x = resultInventory.ticketBank.getPrivate.filter(e => e.referral !== true);
            x.forEach((pt, index) => {
              ticketMap[pt._id] = index;
            });
            this.setState({
              tickets: x || [],
              ticketMap,
              isLoading: false,
              eventName: eventResult.event.get.name,
              onSale: eventResult.event.get.onSale === false ? false : true,
              currency: eventResult.event.get.currency ? eventResult.event.get.currency : 'USD',
              capacityRemaining: eventResult.event.get.capacityRemaining
            });
          } else {
            this.setState({
              isLoading: false,
              eventName: eventResult.event.get.name,
              onSale: eventResult.event.get.onSale === false ? false : true,
              currency: eventResult.event.get.currency ? eventResult.event.get.currency : 'USD',
              capacityRemaining: eventResult.event.get.capacityRemaining
            });
          }

        })
      });
    })
  }

  public handleBackToActivation() {
    window.location.reload();
  }

  public resetChangeMade() {
    this.setState({ modified: false })
  }

  public changeMade() {
    this.setState({ modified: true })
  }
  public openErrorModal() {
    openModal(<div>
      <p>
        An unpexpected error occured while activating your ticket.<br />
        Reload the webpage and try again.<br />
      </p>
    </div>, 'Activation Error', []);
  }

  public render() {

    const eventId = stripUriParamsString(this.props.match.params.eventId);

    const roleChange = gql`
		  subscription {
		    roleChange
		  }
    `;

    const ticketInventoryUpdate = gql`
      subscription {
        updatedTicketInventory(eventId:"${eventId}")
      }
    `;

    const ticketActivation = gql`
      subscription {
        ticketActivated(eventIds:"${eventId}")
      }
    `;

    const eventDeleted = gql`
      subscription {
        eventDeletedNowWhat(eventId:"${eventId}")
      }
    `;

    if (this.state.error === true) {
      return <img height={0} width={0} onLoad={this.openErrorModal} />;
    }

    if (this.state.activatedTicketCode !== null && this.state.activatedTicketCode !== undefined) {
      return (
        <div>
          <div className='div_holder_2'>
            <ContentLoader isLoading={this.state.isLoading}>
              <div>

                <Subscription subscription={roleChange}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {

                      const events = {}
                      Object.keys(this.props.user.events).map((key) => {
                        if (this.props.user.events[key].id === data.roleChange[1]) {
                          events[key] = { id: this.props.user.events[key].id, roles: [data.roleChange[2]] }
                        } else {
                          events[key] = this.props.user.events[key]
                        }
                      });

                      const newUser = {
                        ...this.props.user,
                        events
                      }
                      this.handleRoleChange(newUser);
                      return <Redirect to="/manage/events" />;
                    }
                    return null;
                  }}
                </Subscription>
                <div>
                  <p />
                  {
                    this.state.isLoading ? null : <EventToolbar key={this.props.user.id} userId={this.props.user.id} eventId={eventId} sell={true} eventName={this.state.eventName} />
                  }
                  <p />
                </div>
                <div className="reduce-width-big-screens">
                  <Row>
                    <Col style={{ width: '100%' }}>
                      <Card>
                        <div style={{
                          paddingRight: '5%', paddingLeft: '5%'
                        }}>
                          <div>
                            <p><br /></p>
                            <h4 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Share this Offer
                            </h4>
                          </div>
                          <p />
                          <div className="text-left" style={{ width: "50%" }}>
                            <button onClick={this.handleBackToActivation} className="new-button-white-4" style={{ border: 'none' }}>
                              BACK
                            </button>
                          </div>
                          <p />
                          <div>
                            <Text defaultValue=
                              {AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'istkt.com/' + this.state.activatedTicketCode
                                : AppConfig.hostUrl + '/' + this.state.activatedTicketCode
                              }
                            />
                            <div style={{ width: "100%" }}>
                              <div style={{ textAlign: 'center' }} >
                                <p />
                                <div>
                                  <div>
                                    <a style={{ border: 'none', textDecoration: 'none' }} href={AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'http://istkt.com/' + this.state.activatedTicketCode
                                      : AppConfig.hostUrl + '/' + this.state.activatedTicketCode
                                    }
                                      target="_blank">
                                      <div className="new-button-white-3" style={{ textDecoration: 'none', width: '150px' }}>
                                        OPEN LINK
                                  </div>
                                    </a>
                                  </div>
                                  <p />
                                  <div>
                                    <CopyToClipboard text={AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'http://istkt.com/' + this.state.activatedTicketCode
                                      : AppConfig.hostUrl + '/' + this.state.activatedTicketCode
                                    } style={{ textDecoration: 'none', width: '150px' }}>
                                      <button className="new-button-white-3" style={{ border: 'none', cursor: 'pointer' }} onClick={this.copied}>COPY LINK</button>
                                    </CopyToClipboard>
                                  </div>
                                </div>

                              </div>
                            </div>
                            <p style={{ width: '100%', textAlign: 'center' }}><br />
                              Ask customer to hover camera over QR code to view offer.
                            </p>
                            <div className="align-center" style={{ margin: "auto", textAlign: "center" }}>
                              <QRCode
                                bgColor="#FFFFFF"
                                fgColor="#000000"
                                style={{ width: 200 }}
                                value={AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'istkt.com/' + this.state.activatedTicketCode
                                  : AppConfig.hostUrl + '/' + this.state.activatedTicketCode
                                }
                              />
                              {this.state.copied ? <div><p /><Success content={"Link copied!"} /></div> : null}
                              <p><br /></p>
                            </div>
                            <div >
                              <div>
                                {Object.keys(this.state.ticketOrder).map((tkey) => {
                                  if (this.state.ticketOrder[tkey].count !== 0) {
                                    return (
                                      <ActivatedTicketListItem
                                        key={"titem-" + tkey}
                                        price={this.state.ticketOrder[tkey].price * this.state.ticketOrder[tkey].count}
                                        qty={this.state.ticketOrder[tkey].count}
                                        name={this.state.ticketOrder[tkey].name}
                                        currency={this.state.currency}
                                      />
                                    )
                                  }
                                })}
                              </div>
                              <p><br /></p>
                              <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                                <div style={{ width: '85%', textAlign: 'center' }}>
                                  <div>
                                    <Text
                                      placeholder="Share via email..."
                                      value={this.state.email}
                                      onChange={(e) => {
                                        e.preventDefault();
                                        this.emailInputChange(e);
                                      }}
                                    />
                                  </div>
                                  {
                                    this.state.emailSent ? <br /> :
                                      <button
                                        className='new-button-blue-outline'
                                        onClick={e =>
                                          this.emailOffer()
                                        }
                                        // style={{ width: '65px' }}
                                        id="send"
                                      >
                                        Send
                                      </button>
                                  }
                                </div>
                              </div>
                              <p><br />
                                {
                                  this.state.invalidEmail ?
                                    <Error content="Invalid email entered" /> : null
                                }
                                {
                                  this.state.emailSent ?
                                    <Success content="Offer has been emailed!" /> : null
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </Card>
                      <p><br /></p>
                    </Col>
                  </Row>
                  <p><br /></p>
                </div>
              </div>
            </ContentLoader>
          </div>
        </div>
      );
    }

    const subdomain = this.state.teamMap.customSubdomain
    const generalTicketLink = (subdomain !== undefined && subdomain !== null && subdomain !== '') ? ('https://' + subdomain + '.isotopeticketing.com')
      : (AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? ('http://istkt.com/event-' + this.state.teamMap.code)
        : AppConfig.hostUrl + "/event-" + this.state.teamMap.code)

    const user = this.state.teamMap.teamMap.find(item => {
      return item.userId === this.props.user.id
    })

    let index = '';
    if (user !== undefined) {
      index = user.index
    }

    const referralLink = AppConfig.hostUrl === 'https://platform.isotopeticketing.com' ? 'http://istkt.com/event-' + this.state.teamMap.code + '-' + index
      : AppConfig.hostUrl + "/event-" + this.state.teamMap.code + '-' + index


    const tickets = this.state.tickets.sort((a, b) => {
      if (a.price < b.price) {
        return -1;
      }
      if (a.price > b.price) {
        return 1;
      }
      return 0;
    })

    return (
      <div>
        <div className='div_holder_2'>
          <ContentLoader isLoading={this.state.isLoading}>
            <div>
              <Subscription subscription={ticketInventoryUpdate}>
                {({ data }) => {
                  if (data !== undefined && data !== null && data.updatedTicketInventory !== null) {
                    if (data.updatedTicketInventory !== this.state.updateString) {
                      this.reloadData(data.updatedTicketInventory, 1)
                    }
                    return null;
                  }
                  return null;
                }}
              </Subscription>

              <Subscription subscription={ticketActivation}>
                {({ data }) => {
                  if (data !== undefined && data !== null && data.ticketActivated !== null) {
                    if (data.ticketActivated !== this.state.updateString4) {
                      if (this.state.modified === true) {
                        return <img onLoad={this.resetChangeMade} height='0px' width='0px' style={{ display: 'none' }} />
                      } else {
                        this.reloadData(data.ticketActivated, 4)
                      }
                    }
                    return null;
                  }
                  return null;
                }}
              </Subscription>

              <Subscription subscription={eventDeleted}>
                {({ data }) => {
                  if (data !== undefined && data !== null && data.eventDeletedNowWhat === true) {
                    return <Redirect to="/manage/events" />;
                  }
                  return null;
                }}
              </Subscription>

              <Subscription subscription={roleChange}>
                {({ data }) => {
                  if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {

                    const events = {}
                    Object.keys(this.props.user.events).map((key) => {
                      if (this.props.user.events[key].id === data.roleChange[1]) {
                        events[key] = { id: this.props.user.events[key].id, roles: [data.roleChange[2]] }
                      } else {
                        events[key] = this.props.user.events[key]
                      }
                    });

                    const newUser = {
                      ...this.props.user,
                      events
                    }
                    this.handleRoleChange(newUser);
                    return <Redirect to="/manage/events" />;
                  }
                  return null;
                }}
              </Subscription>
              <div>
                <p />
                {
                  this.state.isLoading ? null : <EventToolbar key={this.props.user.id} userId={this.props.user.id} eventId={eventId} sell={true} eventName={this.state.eventName} />
                }
                <p />
              </div>
              <div className="reduce-width-big-screens">
                <Row>
                  <Col style={{ width: '100%' }}>
                    <Card>
                      <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                        <div>
                          <p><br /></p>
                          <div style={{ width: '100%' }}>
                            <h4 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Make a Private Offer</h4>
                          </div>
                        </div>
                        <p><br /></p>
                        <div>
                          <p />
                          {
                            tickets.length > 0
                              ? tickets.map((ticket: any) => {
                                return (
                                  <TicketListItem
                                    key={"titem-" + ticket._id}
                                    price={ticket.price}
                                    name={ticket.name}
                                    id={ticket._id}
                                    available={ticket.available}
                                    qty={this.getQty(ticket._id)}
                                    handleAdd={this.handleAddTicket}
                                    handleSubstract={this.handleAddTicket}
                                    currency={this.state.currency}
                                    description={ticket.description}
                                  />
                                );
                              })
                              : <h3 style={{ width: '100%', color: '#8c8d94', paddingRight: '10%', paddingLeft: '10%' }}>Contact event host for tickets to sell.</h3>
                          }
                          <p><br /></p>
                          <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                            <Text label="Who's this for? " value={this.state.formData.comment}
                              onChange={e =>
                                this.handleFormInputChange({
                                  target: {
                                    name: "comment",
                                    value: e.target.value
                                  }
                                })
                              }
                              placeholder='(Optional)'
                            />
                            <p />
                            <div className="row">
                              <div className="col">
                                <h6 style={{ paddingLeft: '5px' }}>
                                  Subtotal<br />
                                  <span className="sexyBlack">
                                    {
                                      this.state.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                    {(this.countTotalPrice() / 100).toFixed(2)}</span>
                                </h6>
                              </div>
                              <div className="col text-right">
                                {
                                  this.countTotalTickets() === 0 ? null :
                                    <button
                                      className="new-button-save"
                                      onClick={this.handleActivateTicket}
                                      style={{
                                        border: 'none',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      Share
                                  </button>
                                }
                                <p><br /></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p />
                    </Card>
                    <p><br /></p><Card>
                      <div className={' div_holder_3'} style={{ maxWidth: '400px', textAlign: 'center' }}>
                        <p><br /></p>
                        <h4 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>General Ticket Link</h4>
                        <a href={
                          generalTicketLink
                        } style={{
                          textDecoration: 'none', color: '#4d5adf'
                        }}
                        >
                          OPEN
                            </a>
                        <br /><br />
                        <CopyToClipboard text={generalTicketLink}
                          style={{ textDecoration: 'none' }}>
                          <button className="new-button-white-3" style={{ border: 'none', cursor: 'pointer' }} onClick={this.generalLinkCopied}>COPY</button>
                        </CopyToClipboard>
                        {
                          this.state.generalLinkCopied ?
                            <div><br /><Success content="Link copied!" /></div> : null
                        }
                        <p />
                      </div>
                      {
                        this.state.showReferral ?
                          <div>
                            <hr />
                            <br />
                            <div className={' div_holder_3'} style={{ maxWidth: '400px', textAlign: 'center' }}>
                              <h4 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Your Referral Link</h4>
                              <a href={referralLink} style={{
                                textDecoration: 'none', color: '#4d5adf'
                              }}>
                                OPEN
                                    </a>
                              <br /><br />
                              <CopyToClipboard text={referralLink} style={{ textDecoration: 'none' }}>
                                <button className="new-button-white-3" style={{ border: 'none', cursor: 'pointer' }} onClick={this.referralLinkCopied}>COPY</button>
                              </CopyToClipboard>
                              <br />
                              {
                                this.state.referralLinkCopied ?
                                  <div><br /><Success content="Link copied!" /></div> : <br />
                              }
                            </div>
                          </div> : null
                      }
                      <div>
                        <p />
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <PrintedTicketActivation
                            eventId={stripUriParamsString(this.props.match.params.eventId)}
                            changeMade={this.changeMade}
                            currency={this.state.currency}
                          />
                        </div>
                        <p />
                      </div>
                    </Card>
                    <p><br /></p>
                  </Col>
                </Row>
              </div>
            </div>
          </ContentLoader>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: UserDucks.getUser(state),
    user: UserDucks.getUser(state)
  }
}

export default withCookies(withRouter(connect(mapStateToProps)(ActivateDigitalTicketPage)))



// WEBPACK FOOTER //
// ./src/pages/manage/tickets/activate/digital/ActivateDigitalTicket.page.tsx